import React from "react";
import Select, { components, useStateManager } from "react-select";
import { customStyles } from "../../../../pages/customStyles";
import MonthDatePicker from "../../MonthDatePicker";
import { ImageUrlPrefix } from "../../../../labels";
import { TechFaculty } from "./TechFaculty";

const FacultyProfileStep3 = ({
  styles,
  educationQualification,
  handleChange,
  handleCheckboxChange,
  handleEdu,
  handleYearChange_month,
  handleMonthChange_month,
  handleEYDate,
  txtAdEduc,
  listErrors,
  sslcCerficates,
  handleEdus,
  list,
  ipMajor,
  ugOption,
  pgDegree,
  ugDegree,
  iPGisOther,
  pgMajor,
  ipgDegree,
  handleEduMajor,
  mOption,
  major,
  uGisOther,
  classOption,
  txtAdUdeg,
  txtAdUMaj,
  dmajor,
  txtAdUMajOther,
  txtAdUpass,
  txtAdUCer,
  txtAdUmarks,
  txtAdUclass,
  txtAdUins,
  txtAdUfile,
  txtAdPdeg,
  diplomaDegree,
  txtAdPMaj,
  pcDegree,
  phDegree,
  pcMajor,
  txtAdPhdMaj,
  PhMajor,
  pHDisOther,
  pGisOther,
  txtAdPMajOther,
  txtAdPpass,
  txtAdPCer,
  txtAdPmarks,
  txtAdPclass,
  txtAdPins,
  txtAdPfile,
  txtAdIfile,
  txtAdIdeg,
  txtAdIMaj,
  txtAdIMajOther,
  txtAdIpass,
  txtAdICer,
  txtAdImarks,
  txtAdIclass,
  txtAdIins,
  txtAdPhddeg,
  txtAdPhdMajOther,
  txtAdPhdpass,
  txtAdPhdCer,
  txtAdPhdmarks,
  txtAdPhdclass,
  txtAdPhdins,
  txtAdPhdfile,
  txtAdDfile,
  txtAdDins,
  txtAdDclass,
  txtAdDmarks,
  txtAdDCer,
  txtAdDpass,
  txtAdDMajOther,
  dipisOther,
  txtAdDMaj,
  txtAdDdeg,
  txtAdCfile,
  txtAdCins,
  txtAdCclass,
  txtAdCmarks,
  txtAdCCer,
  txtAdCpass,
  txtAdCMajOther,
  pCisOther,
  txtAdCMaj,
  txtAdCdeg,
  txtAdOfile,
  txtAdOins,
  txtAdOclass,
  txtAdOmarks,
  txtAdOCer,
  txtAdOpass,
  txtAdOMaj,
  txtAdOdeg,
  txtAdSpc,
  // Technical Qualification
  AddQualification,
  DeleteQual,
  techQualification,
  technicalOption,
  TechhandleChange_date,
  TechhandleChange,
  TechhandleChanges,
  txtadTech,
  handleAdd,
}) => {
  return (
    <div className="AcademicBackgroundForm">
      <fieldset className="mt-3">
        <legend className="w-auto">Educational Qualification</legend>
        <form className="row g-3">
          <div className="col-12">
            <label for="qualification" class="form-label confirm_value ">
              Select All The Academic Certificates You Have
            </label>
            <div className="mb-3 d-flex align-items-center">
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  ref={txtAdEduc}
                  type="checkbox"
                  id="EducationQualification3"
                  value="UG"
                  checked={educationQualification.includes("UG")}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualification3">UG</label>
              </div>
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  type="checkbox"
                  id="EducationQualification4"
                  value="PG"
                  checked={educationQualification.includes("PG")}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualification4" class="">
                  PG
                </label>
              </div>
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  type="checkbox"
                  id="EducationQualification5"
                  value="Integrated PG"
                  checked={educationQualification.includes("Integrated PG")}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualification5" class="">
                  Integrated PG
                </label>
              </div>
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  type="checkbox"
                  id="EducationQualificationphd"
                  value="phd"
                  checked={educationQualification.includes("phd")}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualificationphd" class="">
                  Ph.D
                </label>
              </div>
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  type="checkbox"
                  id="EducationQualification6"
                  value="Diploma"
                  checked={educationQualification.includes("Diploma")}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualification6" class="">
                  Diploma
                </label>
              </div>
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  type="checkbox"
                  id="EducationQualification7"
                  value="Professional Courses"
                  checked={educationQualification.includes(
                    "Professional Courses"
                  )}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualification7" class="">
                  Professional Courses
                </label>
              </div>
              <div className="me-2">
                <input
                  className={`${styles.checkBox_input} me-2`}
                  type="checkbox"
                  id="EducationQualification8"
                  value="Others"
                  checked={educationQualification.includes("Others")}
                  onChange={handleCheckboxChange}
                ></input>
                <label htmlFor="EducationQualification8" class="">
                  Others
                </label>
              </div>
            </div>
          </div>
        </form>
      </fieldset>

      {/* UG */}
      {educationQualification.includes("UG") && (
        <fieldset className="mt-3">
          <legend className="w-auto">UG</legend>
          <form className="row g-3">
            {/* UG Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdUdeg}
                id="FacultyUGDegree"
                name="UGDegree"
                disabled={list.admission_status === 1 ? true : false}
                value={ugOption.UG}
                onChange={(option) => handleEdus(option, "UG", "UGDegree")}
                options={ugDegree.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                isSearchable={true}
                placeholder="Select an option"
                maxMenuHeight={200}
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                }
                styles={customStyles}
              />

              {listErrors.UGDegree && (
                <small className="error_message">{listErrors.UGDegree}</small>
              )}
            </div>

            {/* UG Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdUMaj}
                id="FacultyUGMajor"
                disabled={list.admission_status === 1 ? true : false}
                name="UGMajor"
                value={mOption.UGMajor}
                onChange={(option) => handleEduMajor(option, "UG", "UGMajor")}
                options={major.sort((a, b) => a.label.localeCompare(b.label))}
                isSearchable={true}
                placeholder="Select an option"
                maxMenuHeight={200}
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                }
                styles={customStyles}
              />
              {listErrors.UGMajor && (
                <small className="error_message">{listErrors.UGMajor}</small>
              )}
            </div>

            {uGisOther && (
              <div className="col-md-6 col-sm-12">
                <div className="forms ">
                  <label
                    htmlFor="UGMajor_Other"
                    className="form-label confirm_value"
                  >
                    Major(Other)
                  </label>
                  <input
                    ref={txtAdUMajOther}
                    id="UGMajor_Other"
                    type="text"
                    name="UGMajor_Other"
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    placeholder="Please enter major"
                    onChange={(e) => handleEdu("UG", e)}
                    value={sslcCerficates[0].UGMajor_Other}
                    required
                  />

                  {listErrors.UGMajor_Other && (
                    <small className="error_message">
                      {listErrors.UGMajor_Other}
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"UG"}
                txtAdSpass={txtAdUpass}
                name={"UGYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[0].UGYearpassing}
              />
              {listErrors.UGYearpassing && (
                <small className="error_message">
                  {listErrors.UGYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                type="text"
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                placeholder="Enter the certificate number"
                ref={txtAdUCer}
                id="UGCertificateNumber"
                name="UGCertificateNumber"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("UG", e)}
                value={sslcCerficates[0].UGCertificateNumber}
                autoComplete="UGCertificate Number"
                required
              />
              {listErrors.UGCertificateNumber && (
                <small className="error_message">
                  {listErrors.UGCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                placeholder="Enter the marks percentage"
                ref={txtAdUmarks}
                id="UGMarksPercentage"
                type="number"
                disabled={list.admission_status === 1 ? true : false}
                name="UGMarksPercentage"
                onChange={(e) => handleEdu("UG", e)}
                value={sslcCerficates[0].UGMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.UGMarksPercentage && (
                <span className="error_message">
                  {listErrors.UGMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                isSearchable
                placeholder="Please select"
                ref={txtAdUclass}
                id="FacultyUGClassName"
                type="text"
                disabled={list.admission_status === 1 ? true : false}
                name="UGClassName"
                value={mOption.UGClassName}
                onChange={(option) =>
                  handleEduMajor(option, "UG", "UGClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                maxMenuHeight={200}
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                }
                styles={customStyles}
              />
              {listErrors.UGClassName && (
                <span className="error_message">
                  {listErrors.UGClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                ref={txtAdUins}
                id="UGNameInstitute"
                type="text"
                name="UGNameInstitute"
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                placeholder="Enter the college / university"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("UG", e)}
                value={sslcCerficates[0].UGNameInstitute}
                autoComplete="UGNameInstitute"
                required
              />
              {listErrors.UGNameInstitute && (
                <span className="error_message">
                  {listErrors.UGNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[0].UG_Path !== "" &&
                    sslcCerficates[0].UG_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[0].UG_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      ref={txtAdUfile}
                      id="UG_Path"
                      type="file"
                      name="UG_Path"
                      disabled={list.admission_status === 1 ? true : false}
                      onChange={(e) => handleEdu("UG", e)}
                      placeholder="UG_Path"
                      autoComplete="UG_Path"
                      required
                    />
                  </div>

                  {sslcCerficates[0].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[0].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.UG_Path && (
                    <span className="error_message">
                      {listErrors.UG_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* PG */}
      {educationQualification.includes("PG") && (
        <fieldset className="mt-3">
          <legend className="w-auto">PG</legend>
          <form className="row g-3">
            {/* PG Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                id="FacultyPGDegree"
                disabled={list.admission_status === 1 ? true : false}
                ref={txtAdPdeg}
                name="PGDegree"
                value={ugOption.PG} // Use ugOption.ug as the value
                onChange={(option) => handleEdus(option, "PG", "PGDegree")}
                options={pgDegree.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.PGDegree && (
                <small className="error_message">{listErrors.PGDegree}</small>
              )}
            </div>

            {/* UG Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                id="FacultyPGMajor"
                name="PGMajor"
                disabled={list.admission_status === 1 ? true : false}
                ref={txtAdPMaj}
                value={mOption.PGMajor} // Use ugOption.ug as the value
                onChange={(option) => handleEduMajor(option, "PG", "PGMajor")}
                options={pgMajor.sort((a, b) => a.label.localeCompare(b.label))} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.PGMajor && (
                <small className="error_message">{listErrors.PGMajor}</small>
              )}
            </div>

            {pGisOther && (
              <div className="col-md-6 col-sm-12">
                <div className="forms ">
                  <label
                    htmlFor="UGMajor_Other"
                    className="form-label confirm_value"
                  >
                    Major(Other)
                  </label>
                  <input
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    type="text"
                    placeholder="Please Enter Major"
                    ref={txtAdPMajOther}
                    id="PGMajor_Other"
                    name="PGMajor_Other"
                    disabled={list.admission_status === 1 ? true : false}
                    onChange={(e) => handleEdu("PG", e)}
                    defaultValue={sslcCerficates[1].PGMajor_Other}
                    required
                  />

                  {listErrors.PGMajor_Other && (
                    <small className="error_message">
                      {listErrors.PGMajor_Other}
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"PG"}
                txtAdSpass={txtAdPpass}
                name={"PGYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[1].PGYearpassing}
              />
              {listErrors.PGYearpassing && (
                <small className="error_message">
                  {listErrors.PGYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdPCer}
                id="PGCertificateNumber"
                type="text"
                disabled={list.admission_status === 1 ? true : false}
                name="PGCertificateNumber"
                onChange={(e) => handleEdu("PG", e)}
                placeholder="Certificate Number"
                value={sslcCerficates[1].PGCertificateNumber}
                autoComplete="Certificate Number"
                required
              />
              {listErrors.PGCertificateNumber && (
                <small className="error_message">
                  {listErrors.PGCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdPmarks}
                id="PGMarksPercentage"
                type="number"
                disabled={list.admission_status === 1 ? true : false}
                name="PGMarksPercentage"
                onChange={(e) => handleEdu("PG", e)}
                placeholder="Marks Percentage"
                value={sslcCerficates[1].PGMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.PGMarksPercentage && (
                <span className="error_message">
                  {listErrors.PGMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdPclass}
                id="FacultyPGClassName"
                type="text"
                disabled={list.admission_status === 1 ? true : false}
                name="PGClassName"
                value={mOption.PGClassName}
                onChange={(option) =>
                  handleEduMajor(option, "PG", "PGClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.PGClassName && (
                <span className="error_message">
                  {listErrors.PGClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                //
                ref={txtAdPins}
                id="PGNameInstitute"
                type="text"
                disabled={list.admission_status === 1 ? true : false}
                name="PGNameInstitute"
                onChange={(e) => handleEdu("PG", e)}
                placeholder="Name of the college / university"
                value={sslcCerficates[1].PGNameInstitute}
                autoComplete="PGNameInstitute"
                required
              />
              {listErrors.PGNameInstitute && (
                <span className="error_message">
                  {listErrors.PGNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[1].PG_Path !== "" &&
                    sslcCerficates[1].PG_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[1].PG_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      disabled={list.admission_status === 1 ? true : false}
                      ref={txtAdPfile}
                      id="PG_Path"
                      type="file"
                      name="PG_Path"
                      onChange={(e) => handleEdu("PG", e)}
                      placeholder="Path"
                      autoComplete="Path"
                      required
                    />
                  </div>

                  {sslcCerficates[1].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[1].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.UG_Path && (
                    <span className="error_message">
                      {listErrors.UG_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* Integrated PG */}
      {educationQualification.includes("Integrated PG") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Integrated PG</legend>
          <form className="row g-3">
            {/* Integrated PG Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdIdeg}
                id="FacultyIPDegree"
                name="IPDegree"
                disabled={list.admission_status === 1 ? true : false}
                value={ugOption.Integrated_PG}
                onChange={(option) =>
                  handleEdus(option, "Integrated PG", "IPDegree")
                }
                options={ipgDegree.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.IPDegree && (
                <small className="error_message">{listErrors.IPDegree}</small>
              )}
            </div>

            {/* UG Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>
              {sslcCerficates[2].IPMajor === "Others" || iPGisOther === true ? (
                <input
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  ref={txtAdIMaj}
                  id="FacultyIPMajor"
                  name="IPMajor"
                  disabled={list.admission_status === 1 ? true : false}
                  onChange={(e) => handleEdu("Integrated PG", e)}
                  value={sslcCerficates[2].IPMajor}
                  required
                  placeholder="Please enter major"
                />
              ) : (
                <Select
                  className="shadow-none input-font-size margin-left-zero"
                  ref={txtAdIMaj}
                  id="FacultyIPMajor"
                  name="IPMajor"
                  disabled={list.admission_status === 1 ? true : false}
                  value={mOption.IPMajor} // Use ugOption.ug as the value
                  onChange={(option) =>
                    handleEduMajor(option, "Integrated PG", "IPMajor")
                  }
                  options={ipMajor.sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )} // Sort options alphabetically by label
                  isSearchable={true} // Enables search functionality
                  placeholder="Select an option"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />
              )}
              {listErrors.IPMajor && (
                <small className="error_message">{listErrors.IPMajor}</small>
              )}
            </div>

            {iPGisOther && (
              <div className="col-md-6 col-sm-12">
                <div className="forms ">
                  <label
                    htmlFor="UGMajor_Other"
                    className="form-label confirm_value"
                  >
                    Major(Other)
                  </label>
                  <input
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    ref={txtAdIMajOther}
                    id="IPMajor_Other"
                    name="IPMajor_Other"
                    disabled={list.admission_status === 1 ? true : false}
                    onChange={(e) => handleEdu("Integrated PG", e)}
                    value={sslcCerficates[2].IPMajor_Other}
                    required
                    placeholder="Please enter major"
                  />

                  {listErrors.IPMajor_Other && (
                    <small className="error_message">
                      {listErrors.IPMajor_Other}
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"Integrated PG"}
                ref={txtAdIpass}
                name={"IPYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[2].IPYearpassing}
              />
              {listErrors.IPYearpassing && (
                <small className="error_message">
                  {listErrors.IPYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdICer}
                id="IPCertificateNumber"
                type="text"
                disabled={list.admission_status === 1 ? true : false}
                name="IPCertificateNumber"
                onChange={(e) => handleEdu("Integrated PG", e)}
                placeholder="Certificate Number"
                value={sslcCerficates[2].IPCertificateNumber}
                autoComplete="Certificate Number"
                required
              />
              {listErrors.IPCertificateNumber && (
                <small className="error_message">
                  {listErrors.IPCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdImarks}
                id="IPMarksPercentage"
                type="number"
                name="IPMarksPercentage"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Integrated PG", e)}
                placeholder="Marks Percentage"
                value={sslcCerficates[2].IPMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.IPMarksPercentage && (
                <span className="error_message">
                  {listErrors.IPMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdIclass}
                id="FacultyIPClassName"
                type="text"
                name="IPClassName"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.IPClassName}
                onChange={(option) =>
                  handleEduMajor(option, "Integrated PG", "IPClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.IPClassName && (
                <span className="error_message">
                  {listErrors.IPClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdIins}
                id="IPNameInstitute"
                type="text"
                name="IPNameInstitute"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Integrated PG", e)}
                placeholder="Name of the college / university"
                value={sslcCerficates[2].IPNameInstitute}
                autoComplete="IPNameInstitute"
                required
              />
              {listErrors.IPNameInstitute && (
                <span className="error_message">
                  {listErrors.IPNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[2].IP_Path !== "" &&
                    sslcCerficates[2].IP_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[2].IP_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      ref={txtAdIfile}
                      id="IP_Path"
                      type="file"
                      name="IP_Path"
                      disabled={list.admission_status === 1 ? true : false}
                      onChange={(e) => handleEdu("Integrated PG", e)}
                      placeholder="Path"
                      autoComplete="Path"
                      required
                    />
                  </div>

                  {sslcCerficates[2].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[2].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.IP_Path && (
                    <span className="error_message">
                      {listErrors.IP_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* Ph.D */}
      {educationQualification.includes("phd") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Ph.D</legend>
          <form className="row g-3">
            {/* Ph.D Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdPhddeg}
                id="FacultyPHDDegree"
                name="PHDDegree"
                disabled={list.admission_status === 1 ? true : false}
                value={ugOption.phd} // Use ugOption.ug as the value
                onChange={(option) => handleEdus(option, "phd", "PHDDegree")}
                options={phDegree.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.PHDDegree && (
                <small className="error_message">{listErrors.PHDDegree}</small>
              )}
            </div>

            {/* UG Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>

              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdPhdMaj}
                id="FacultyPHDMajor"
                name="PHDMajor"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.PHDMajor} // Use ugOption.ug as the value
                onChange={(option) => handleEduMajor(option, "phd", "PHDMajor")}
                options={PhMajor.sort((a, b) => a.label.localeCompare(b.label))} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.PHDMajor && (
                <small className="error_message">{listErrors.PHDMajor}</small>
              )}
            </div>

            {pHDisOther && (
              <div className="col-md-6 col-sm-12">
                <div className="forms ">
                  <label
                    htmlFor="UGMajor_Other"
                    className="form-label confirm_value"
                  >
                    Major(Other)
                  </label>
                  <input
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    type="text"
                    placeholder="Please Enter Major"
                    ref={txtAdPhdMajOther}
                    id="PHDMajor_Other"
                    name="PHDMajor_Other"
                    onChange={(e) => handleEdu("phd", e)}
                    value={sslcCerficates[3].PHDMajor_Other}
                    required
                  />

                  {listErrors.PHDMajor_Other && (
                    <small className="error_message">
                      {listErrors.PHDMajor_Other}
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"phd"}
                ref={txtAdPhdpass}
                name={"PHDYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[3].PHDYearpassing}
              />
              {listErrors.PHDYearpassing && (
                <small className="error_message">
                  {listErrors.PHDYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdPhdCer}
                id="PHDCertificateNumber"
                type="text"
                name="PHDCertificateNumber"
                onChange={(e) => handleEdu("phd", e)}
                placeholder="Certificate Number"
                value={sslcCerficates[3].PHDCertificateNumber}
                autoComplete="Certificate Number"
                required
              />
              {listErrors.PHDCertificateNumber && (
                <small className="error_message">
                  {listErrors.PHDCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdPhdmarks}
                id="PHDMarksPercentage"
                type="number"
                name="PHDMarksPercentage"
                onChange={(e) => handleEdu("phd", e)}
                placeholder="Marks Percentage"
                value={sslcCerficates[3].PHDMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.PHDMarksPercentage && (
                <span className="error_message">
                  {listErrors.PHDMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdPhdclass}
                id="FacultyPHDClassName"
                type="text"
                name="PHDClassName"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.PHDClassName}
                onChange={(option) =>
                  handleEduMajor(option, "phd", "PHDClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.PHDClassName && (
                <span className="error_message">
                  {listErrors.PHDClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdPhdins}
                id="PHDNameInstitute"
                type="text"
                name="PHDNameInstitute"
                onChange={(e) => handleEdu("phd", e)}
                placeholder="Name of the college / university"
                value={sslcCerficates[3].PHDNameInstitute}
                autoComplete="PHDNameInstitute"
                required
              />
              {listErrors.PHDNameInstitute && (
                <span className="error_message">
                  {listErrors.PHDNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[3].PHD_Path !== "" &&
                    sslcCerficates[3].PHD_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[3].PHD_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      ref={txtAdPhdfile}
                      id="PHD_Path"
                      type="file"
                      name="PHD_Path"
                      onChange={(e) => handleEdu("phd", e)}
                      placeholder="Path"
                      autoComplete="Path"
                      required
                    />
                  </div>

                  {sslcCerficates[3].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[3].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.PHD_Path && (
                    <span className="error_message">
                      {listErrors.PHD_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* Diploma */}
      {educationQualification.includes("Diploma") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Diploma</legend>
          <form className="row g-3">
            {/* Diploma Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdDdeg}
                id="FacultyDDegree"
                name="DDegree"
                disabled={list.admission_status === 1 ? true : false}
                value={ugOption.Diploma} // Use ugOption.ug as the value
                onChange={(option) => handleEdus(option, "Diploma", "DDegree")}
                options={diplomaDegree.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.DDegree && (
                <small className="error_message">{listErrors.DDegree}</small>
              )}
            </div>

            {/* Diploma Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>

              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdDMaj}
                id="FacultyDMajor"
                name="DMajor"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.DMajor} // Use ugOption.ug as the value
                onChange={(option) =>
                  handleEduMajor(option, "Diploma", "DMajor")
                }
                options={dmajor.sort((a, b) => a.label.localeCompare(b.label))} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.DMajor && (
                <small className="error_message">{listErrors.DMajor}</small>
              )}
            </div>

            {dipisOther && (
              <div className="col-md-6 col-sm-12">
                <div className="forms ">
                  <label
                    htmlFor="UGMajor_Other"
                    className="form-label confirm_value"
                  >
                    Major(Other)
                  </label>
                  <input
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    type="text"
                    placeholder="Please Enter Major"
                    ref={txtAdDMajOther}
                    id="DMajor_Other"
                    name="DMajor_Other"
                    disabled={list.admission_status === 1 ? true : false}
                    onChange={(e) => handleEdu("Diploma", e)}
                    value={sslcCerficates[4].DMajor_Other}
                    required
                  />

                  {listErrors.DMajor_Other && (
                    <small className="error_message">
                      {listErrors.DMajor_Other}
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"Diploma"}
                ref={txtAdDpass}
                name={"DYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[4].DYearpassing}
              />
              {listErrors.DYearpassing && (
                <small className="error_message">
                  {listErrors.DYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdDCer}
                id="DCertificateNumber"
                type="text"
                name="DCertificateNumber"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Diploma", e)}
                placeholder="Certificate Number"
                value={sslcCerficates[4].DCertificateNumber}
                autoComplete="Certificate Number"
                required
              />
              {listErrors.DCertificateNumber && (
                <small className="error_message">
                  {listErrors.DCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdDmarks}
                id="DMarksPercentage"
                type="number"
                name="DMarksPercentage"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Diploma", e)}
                placeholder="Marks Percentage"
                value={sslcCerficates[4].DMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.DMarksPercentage && (
                <span className="error_message">
                  {listErrors.DMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdDclass}
                id="FacultyDClassName"
                type="text"
                name="DClassName"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.DClassName}
                onChange={(option) =>
                  handleEduMajor(option, "Diploma", "DClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.DClassName && (
                <span className="error_message">
                  {listErrors.DClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdDins}
                id="DNameInstitute"
                type="text"
                name="DNameInstitute"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Diploma", e)}
                placeholder="Name of the college / university"
                value={sslcCerficates[4].DNameInstitute}
                autoComplete="DNameInstitute"
                required
              />
              {listErrors.DNameInstitute && (
                <span className="error_message">
                  {listErrors.DNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[4].D_Path !== "" &&
                    sslcCerficates[4].D_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[4].D_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      ref={txtAdDfile}
                      id="D_Path"
                      type="file"
                      name="D_Path"
                      disabled={list.admission_status === 1 ? true : false}
                      onChange={(e) => handleEdu("Diploma", e)}
                      placeholder="Path"
                      autoComplete="Path"
                      required
                    />
                  </div>

                  {sslcCerficates[4].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[4].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.D_Path && (
                    <span className="error_message">
                      {listErrors.D_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* Professional Courses */}
      {educationQualification.includes("Professional Courses") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Professional Courses</legend>
          <form className="row g-3">
            {/* Professional Courses Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdCdeg}
                id="FacultyPCDegree"
                name="PCDegree"
                disabled={list.admission_status === 1 ? true : false}
                value={ugOption.Professional_Courses} // Use ugOption.ug as the value
                onChange={(option) =>
                  handleEdus(option, "Professional Courses", "PCDegree")
                }
                options={pcDegree.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.PCDegree && (
                <small className="error_message">{listErrors.PCDegree}</small>
              )}
            </div>

            {/* Professional Courses Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>

              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdCMaj}
                id="FacultyPCMajor"
                name="PCMajor"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.PCMajor} // Use ugOption.ug as the value
                onChange={(option) =>
                  handleEduMajor(option, "Professional Courses", "PCMajor")
                }
                options={pcMajor.sort((a, b) => a.label.localeCompare(b.label))} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />

              {listErrors.PCMajor && (
                <small className="error_message">{listErrors.PCMajor}</small>
              )}
            </div>

            {pCisOther && (
              <div className="col-md-6 col-sm-12">
                <div className="forms ">
                  <label
                    htmlFor="UGMajor_Other"
                    className="form-label confirm_value"
                  >
                    Major(Other)
                  </label>
                  <input
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    type="text"
                    placeholder="Please Enter Major"
                    ref={txtAdCMajOther}
                    id="PCMajor_Other"
                    name="PCMajor_Other"
                    disabled={list.admission_status === 1 ? true : false}
                    onChange={(e) => handleEdu("Professional Courses", e)}
                    defaultValue={sslcCerficates[5].PCMajor_Other}
                    required
                  />

                  {listErrors.PCMajor_Other && (
                    <small className="error_message">
                      {listErrors.PCMajor_Other}
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"Professional Courses"}
                ref={txtAdCpass}
                name={"PCYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[5].PCYearpassing}
              />
              {listErrors.PCYearpassing && (
                <small className="error_message">
                  {listErrors.PCYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdCCer}
                id="PCCertificateNumber"
                type="text"
                name="PCCertificateNumber"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Professional Courses", e)}
                placeholder="Certificate Number"
                value={sslcCerficates[5].PCCertificateNumber}
                autoComplete="Certificate Number"
                required
              />
              {listErrors.PCCertificateNumber && (
                <small className="error_message">
                  {listErrors.PCCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdCmarks}
                id="PCMarksPercentage"
                type="number"
                name="PCMarksPercentage"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Professional Courses", e)}
                placeholder="Marks Percentage"
                value={sslcCerficates[5].PCMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.PCMarksPercentage && (
                <span className="error_message">
                  {listErrors.PCMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdCclass}
                id="FacultyPCClassName"
                type="text"
                name="PCClassName"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.PCClassName}
                onChange={(option) =>
                  handleEduMajor(option, "Professional Courses", "PCClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.PCClassName && (
                <span className="error_message">
                  {listErrors.PCClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdCins}
                id="PCNameInstitute"
                type="text"
                name="PCNameInstitute"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Professional Courses", e)}
                placeholder="Name of the college / university"
                value={sslcCerficates[5].PCNameInstitute}
                autoComplete="PCNameInstitute"
                required
              />
              {listErrors.PCNameInstitute && (
                <span className="error_message">
                  {listErrors.PCNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[5].PC_Path !== "" &&
                    sslcCerficates[5].PC_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[5].PC_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      ref={txtAdCfile}
                      id="PC_Path"
                      type="file"
                      name="PC_Path"
                      disabled={list.admission_status === 1 ? true : false}
                      onChange={(e) => handleEdu("Professional Courses", e)}
                      placeholder="Path"
                      autoComplete="Path"
                      required
                    />
                  </div>

                  {sslcCerficates[5].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[5].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.PC_Path && (
                    <span className="error_message">
                      {listErrors.PC_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* Others */}
      {educationQualification.includes("Others") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Others</legend>
          <form className="row g-3">
            {/* Others Degree */}
            <div className="col-md-6">
              <label htmlFor="ugDegree" className="form-label confirm_value">
                Degree
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdOdeg}
                id="FacultyOtDegree"
                name="OtDegree"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Others", e)}
                value={sslcCerficates[6].OtDegree}
                required
                placeholder="Please Enter Degree name"
              />

              {listErrors.OtDegree && (
                <small className="error_message">{listErrors.OtDegree}</small>
              )}
            </div>

            {/* Others Major */}
            <div className="col-md-6">
              <label htmlFor="ugMajor" className="form-label confirm_value">
                Major
              </label>

              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                placeholder="Please Enter Major"
                ref={txtAdOMaj}
                id="FacultyOtMajor"
                name="OtMajor"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Others", e)}
                defaultValue={sslcCerficates[6].OtMajor}
                required
              />

              {listErrors.OtMajor && (
                <small className="error_message">{listErrors.OtMajor}</small>
              )}
            </div>

            {/* Year of Passing */}
            <div className="col-md-6">
              <label
                htmlFor="year_of_passing"
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                handleYearChange={handleYearChange_month}
                handleMonthChange={handleMonthChange_month}
                disabledProperty={list.admission_status === 1 ? true : false}
                dname={"Others"}
                ref={txtAdOpass}
                name={"OtYearpassing"}
                handleChange={handleEYDate}
                fieldInput={sslcCerficates[6].OtYearpassing}
              />
              {listErrors.OtYearpassing && (
                <small className="error_message">
                  {listErrors.OtYearpassing}
                </small>
              )}
            </div>
            {/* Certificate Number */}
            <div className="col-md-6">
              <label
                htmlFor="certificate_no"
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdOCer}
                id="OtCertificateNumber"
                type="text"
                name="OtCertificateNumber"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Others", e)}
                placeholder="Certificate Number"
                value={sslcCerficates[6].OtCertificateNumber}
                autoComplete="Certificate Number"
                required
              />
              {listErrors.OtCertificateNumber && (
                <small className="error_message">
                  {listErrors.OtCertificateNumber}
                </small>
              )}
            </div>
            {/* Marks Percentage */}
            <div className="col-md-6">
              <label
                htmlFor="marks_percentage"
                className="form-label confirm_value"
              >
                Marks Percentage
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdOmarks}
                id="OtMarksPercentage"
                type="number"
                name="OtMarksPercentage"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Others", e)}
                placeholder="Marks Percentage"
                value={sslcCerficates[6].OtMarksPercentage}
                autoComplete="Marks Percentage"
                required
              />
              {listErrors.OtMarksPercentage && (
                <span className="error_message">
                  {listErrors.OtMarksPercentage || "-"}
                </span>
              )}
            </div>
            {/* Class */}
            <div className="col-md-6">
              <label
                htmlFor="educationBoard"
                className="form-label confirm_value"
              >
                Class
              </label>
              <Select
                className="shadow-none input-font-size margin-left-zero"
                ref={txtAdOclass}
                id="FacultyOtClassName"
                type="text"
                name="OtClassName"
                disabled={list.admission_status === 1 ? true : false}
                value={mOption.OtClassName}
                onChange={(option) =>
                  handleEduMajor(option, "Others", "OtClassName")
                }
                options={classOption.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )} // Sort options alphabetically by label
                isSearchable={true} // Enables search functionality
                placeholder="Select an option"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={customStyles} // Apply custom styles her
              />
              {listErrors.OtClassName && (
                <span className="error_message">
                  {listErrors.OtClassName || "-"}
                </span>
              )}
            </div>
            {/* university Name */}
            <div className="col-md-6">
              <label htmlFor="institute" className="form-label confirm_value">
                Name of the college / university
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdOins}
                id="OtNameInstitute"
                type="text"
                name="OtNameInstitute"
                disabled={list.admission_status === 1 ? true : false}
                onChange={(e) => handleEdu("Others", e)}
                placeholder="Name of the college / university"
                value={sslcCerficates[6].OtNameInstitute}
                autoComplete="OtNameInstitute"
                required
              />
              {listErrors.OtNameInstitute && (
                <span className="error_message">
                  {listErrors.OtNameInstitute || "-"}
                </span>
              )}
            </div>
            {/* Upload Certificate */}

            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {sslcCerficates[6].Ot_Path !== "" &&
                    sslcCerficates[6].Ot_Path !== null && (
                      <a
                        href={`${ImageUrlPrefix}/${sslcCerficates[6].Ot_Path}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      className="InputsSelectFile m-0"
                      ref={txtAdOfile}
                      id="Ot_Path"
                      type="file"
                      name="Ot_Path"
                      disabled={list.admission_status === 1 ? true : false}
                      onChange={(e) => handleEdu("Others", e)}
                      placeholder="Path"
                      autoComplete="Path"
                      required
                    />
                  </div>

                  {sslcCerficates[6].original_file_path && (
                    <div className="mt-1">
                      <span className="m-">
                        {sslcCerficates[6].original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {listErrors.Ot_Path && (
                    <span className="error_message">
                      {listErrors.Ot_Path || "-"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      )}

      {/* Technical Qualification  */}
      {/* <section className="sectionFive"> */}
      {techQualification.map((item, index) => (
        <TechFaculty
          key={item.id}
          index={index}
          AddQualification={AddQualification}
          DeleteQual={DeleteQual}
          length={techQualification.length}
          technicalOption={technicalOption}
          TechhandleChange_date={TechhandleChange_date}
          TechhandleChange={TechhandleChange}
          TechhandleChanges={TechhandleChanges}
          record={item}
          txtadTech={txtadTech}
          handleAdd={handleAdd}
          styles={styles}
        />
      ))}

      {/* </section> */}

      {/* Special / Preferential Qualification */}
      <fieldset className="mt-3">
        <legend className="w-auto">
          Special / Preferential Qualification (if any)
        </legend>
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="spq" className="form-label confirm_value">
              Special / Preferential Qualification
            </label>
            <textarea
              ref={txtAdSpc}
              name="spq"
              id="spq"
              rows="5"
              onChange={handleChange}
              defaultValue={list.spq}
              className="Inputs w-100 rounded-2 input-font-size-sm"
              placeholder="Special / Preferential Qualification"
            ></textarea>
            {listErrors.spq && (
              <small className="error_message">{listErrors.spq}</small>
            )}
          </div>
        </form>
      </fieldset>
    </div>
  );
};

export default FacultyProfileStep3;
